import React, { type HTMLAttributes } from 'react';

import { MenuItemTitleDefault } from '@uncinc/react-drupal-core/dist/Components/RecursiveMenu/index.default';
import type { MenuItemTitleProps } from '@uncinc/react-drupal-core/dist/Components/RecursiveMenu/types';

interface HeadingProps extends React.HTMLProps<HTMLAttributes<HTMLHeadingElement>> {
  level?: number;
}

const Heading: React.FC<HeadingProps> = ({ level = 1, children, ...restProps }) => (
  // We'll never start with H1, since this is only allowed as the title of the current page,
  // so we'll start with H2 for level 1 and work upwards the higher the level is, ending at H6.
  React.createElement(`h${Math.min(level + 1, 6)}`, { ...restProps }, children)
);

// Same as MenuItemTitleDefault from @uncinc/react-drupal-core,
// with the exception that we use a heading instead of a span for nolinks.
const RecursiveMenuItemTitleWithHeading: React.FC<MenuItemTitleProps> = ({
  url,
  title,
  level,
  ...restProps
}) => {
  if (url) {
    return (
      <MenuItemTitleDefault
        {...restProps}
        url={url}
        title={title}
        level={level}
      />
    );
  }

  return (
    <Heading level={level} className="RecursiveMenu__title nolink">
      {title}
    </Heading>
  );
};

export default RecursiveMenuItemTitleWithHeading;
